import GroomingCoachShell from "@/components/GroomingCoachShell";

const HAIR_GOALS = [
  { value: "grow-faster",     label: "Grow hair faster" },
  { value: "hair-loss",       label: "Hair loss" },
  { value: "dry-hair",        label: "Dry hair" },
  { value: "oily-hair",       label: "Oily hair" },
  { value: "dandruff",        label: "Dandruff" },
  { value: "repair-damage",   label: "Repair damaged hair" },
  { value: "better-smell",    label: "Better smelling hair" },
  { value: "shampoo-recs",    label: "Shampoo recs" },
  { value: "conditioner-recs",label: "Conditioner recs" },
];

const LOADING_STEPS = [
  "Reading your hair type & density…",
  "Spotting what's already working…",
  "Targeting your real concerns…",
  "Choosing the right wash cadence…",
  "Picking real products in your budget…",
  "Writing your 30-day kickoff…",
];

export default function HairCoachScreen() {
  return (
    <GroomingCoachShell
      feature="hair"
      endpoint="/hair/analyze"
      title="HAIR COACH"
      hero={{
        eyebrow: "PHOTO-BASED HAIR COACH",
        h1Pre:   "Upload your hair.",
        h1Em:    "Real plan, real products.",
        blurb:   "Hair type · density · concerns. Then a step-by-step routine with how to use everything.",
      }}
      goalsList={HAIR_GOALS}
      goalsKey="hair_goals"
      loadingSteps={LOADING_STEPS}
      backRoute="/improve/grooming"
    />
  );
}
